import React, { Component } from 'react';
import axios from 'axios';
import { compose } from 'recompose';
import { Trans, translate } from 'react-i18next';
import { withRouter, Link, Redirect } from 'react-router-dom';
import moment from 'moment-timezone';
import GoBackButton from '../../../components/GoBackButton';
import Header from '../../../components/Header';

let cancelToken;
let state;
let tokenSession;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class PaymentDomicilioContainerCowork extends Component {
    getInitState = () => {
        return {
            centers: [],
            email: "",
            name: "",
            lastname: "",
            phone: "",
            centro_id: "",
            duracion_id: 2,
            duracion_str: "1 Semana",
            precio: 600,
            city: "",
            new_date: new Date().toISOString().split('T')[0],
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        this.setState({ redirectToHomePage: false });
    }

    componentDidMount() {
        this.reload();
    }

    // Verifica si existe el centro
    componentDidUpdate(prevProps, prevState) {
        if (this.state.centers === prevState.centers) {
            return;
        }
        if (this.props.match.params.coworkid && this.state.centers.length > 0) {
            if (!this.state.centers
                .map((center) => center.id)
                .includes(this.props.match.params.coworkid)
            ) {
                alert("El cowork seleccionado no esta disponible");
                this.props.history.push(`${URI_VENTA_EN_LINEA}/cowork`);
            }
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getListCenter({
            token_id: this.props.getTokenId()
        });


        if (this.props.match.params.coworkid) {
            this.setState({
                centro_id: this.props.match.params.coworkid,
                city: this.props.match.params.coworkid
            })
        }
    }

    getListCenter = (params) => {
        this.props.post(
            "/getListCenter",
            params,
            (response) => this.didGetCenters(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetCenters = (response) => {
        this.setState({ centers: response });
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.history.replace({
            pathname: "payment/" + this.state.centro_id + "/" + this.state.duracion_id,
            state: {
                email: this.state.email,
                name: this.state.name,
                lastname: this.state.lastname,
                phone: this.state.phone,
                duracion_id: this.state.duracion_id,
                duracion_str: this.state.duracion_str,
                precio: this.state.precio,
                new_date: this.state.new_date
            }
        })
    }

    render() {
        const { t } = this.props;
        const today = new Date();
        const centers = this.state.centers || [];
        const city = this.state.city || 1;
        const min_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        // const new_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        const email = this.state.email || ""

        return (
            <form className="content-resvations" onSubmit={this.handleSubmit}>
                <Header>
                    <h2>
                        <Trans>venta_linea.index.cowork.title</Trans>
                    </h2>
                </Header>
                <div className="container-domiciolio">
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms flex-horizontal">
                            <h2 className="page-header">
                                <Trans>venta_linea.payment.personal_info</Trans>
                            </h2>
                            <div className="form-group">
                                <div className="input-group input-lg-xl">
                                    {this.state.centers
                                        ? (
                                            <div className="form-group">
                                                <select
                                                    disabled={true}
                                                    className="form-control input-lg"
                                                    id="city-select"
                                                    value={city}>
                                                    {centers.map((city, index) =>
                                                        (<option key={index} className="opcion-select" value={city.id}>{city.name}</option>))
                                                    }
                                                </select>
                                            </div>
                                        )
                                        : null}

                                </div>
                                <div className="input-group-btn-movil">
                                    <Link
                                        to=
                                        {{
                                            pathname: URI_VENTA_EN_LINEA
                                        }}>
                                        <span className="return-store">
                                            <Trans>venta_linea.payment.change_center</Trans>
                                        </span>
                                    </Link>
                                </div>
                                <br></br>
                                <div className="input-group-btn btn-group input-group-btn-movil">
                                    <div className="grid-3">
                                        <button type="button" onClick={() => this.setState({ duracion_id: 1, duracion_str: "Dia", precio: 300 })} className={this.state.duracion_id === 1 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p>Dia</p>
                                            <p className="btn_store_text">$300.00 USD<br></br>+ IVA</p>
                                        </button>
                                        <button type="button" onClick={() => this.setState({ duracion_id: 2, duracion_str: "Semana", precio: 600 })} className={this.state.duracion_id === 2 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p >Semana</p>
                                            <p className="btn_store_text">$600.00 USD<br></br>+ IVA</p>
                                        </button>
                                        <button type="button" onClick={() => this.setState({ duracion_id: 3, duracion_str: "Mes", precio: 1200 })} className={this.state.duracion_id === 3 ? "btn btn_group_store btn_group_select" : "btn btn_group_store"}>
                                            <p>Mes</p>
                                            <p className="btn_store_text">$1,200.00 USD<br></br>+ IVA</p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6 container-fluid-info-mas" >
                        <div className="panel-resvations container-forms">
                            <div className="forms">
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleEmailChange}
                                            placeholder={t('dashboard.room_payment.holder_email')}
                                            required
                                            type="email"
                                            value={email} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleNameChange}
                                            placeholder={t('dashboard.room_payment.holder_name')}
                                            required
                                            type="text"
                                            value={this.state.name ? this.state.name : ""} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handleLastnameChange}
                                            placeholder={t('dashboard.room_payment.holder_lastname')}
                                            required
                                            type="text"
                                            value={this.state.lastname ? this.state.lastname : ""} />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            autoComplete="off"
                                            className="form-control input-date"
                                            onChange={(e) => this.setState({ new_date: e.target.value })}
                                            placeholder={"Fecha de Inicio"}
                                            required
                                            type="date"
                                            min={min_date}
                                            value={this.state.new_date}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.handlePhoneChange}
                                            placeholder={t('dashboard.room_payment.holder_phone')}
                                            required
                                            type="tel"
                                            // minlength="8"
                                            // maxlength="12"
                                            pattern="[0-9]{10}"
                                            value={this.state.phone} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <span className="return-store">
                                        * <Trans>venta_linea.payment.accept_contact</Trans>
                                    </span>
                                </div>
                                <div className='row'>
                                    <GoBackButton 
                                        isButtonForm
                                        isPayment
                                    />
                                    <button
                                        type='submit'
                                        className="continua_button btn btn-primary col-md-6">
                                        <Trans>dashboard.room_payment.btn_continue</Trans>
                                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }


}

export default compose(
    translate('common'),
    withRouter
)(PaymentDomicilioContainerCowork);


// WEBPACK FOOTER //
// ./src/store/Cowork/Payment/PaymentDomicilioContainerCowork.js